import { render, staticRenderFns } from "./g-live-toc.vue?vue&type=template&id=5ac931fb&scoped=true"
import script from "./g-live-toc.vue?vue&type=script&lang=js"
export * from "./g-live-toc.vue?vue&type=script&lang=js"
import style0 from "./g-live-toc.vue?vue&type=style&index=0&id=5ac931fb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac931fb",
  null
  
)

export default component.exports